import { Box, IconButton, Typography } from "@mui/material";
import styles from "./ViewFaq.module.scss";
import { ArrowIcon } from "../../components/icon-components/ArrowIcon";
import { useAppSelector } from "../../store/hooks";
import { useGetFaqQuery } from "./services/GetFaqApiSlice";
import { useLocation, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { FAQ_FILTER } from "../../utility/constants/common-constants";
import DataLoader from "../../components/custom-data-loader/DataLoader";
import ViewFaqSkeleton from "./ViewFaqSkeleton";
import { useEffect } from "react";

const ViewFaq = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const faqFilterQuery = FAQ_FILTER;
  const preferredLanguage = useAppSelector(
    (state) => state.patientOnboardingStatus.preferredLanguage
  );
  const {
    data: faqData,
    isLoading,
    error,
  } = useGetFaqQuery({
    faqFilterQuery,
    preferredLanguage,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  const navigateBack = () => {
    navigate(location.state?.from ?? -1);
  };

  return (
    <DataLoader
      isLoading={isLoading}
      error={error}
      data={faqData}
      loadingComponent={<ViewFaqSkeleton />}
      emptyComponent={<Typography>No data found.</Typography>}
      errorComponent={
        <Typography color="error">
          FAQ content is currently unavailable.
        </Typography>
      }
    >
      {() => {
        const sanitizedContent = DOMPurify.sanitize(
          faqData.agilityFaqContent.body || ""
        );
        return (
          <Box className={styles.container}>
            {/* Header */}
            <Box className={styles.headingContainer}>
              <Box className={styles.leftHeader}>
                <IconButton onClick={navigateBack}>
                  <ArrowIcon
                    width={20}
                    height={15}
                  />
                </IconButton>
              </Box>
            </Box>

            {/* Content */}
            <Box className={styles.contentContainer}>
              <Typography variant="h2">
                {faqData.agilityFaqContent.title}
              </Typography>

              <Box className={styles.articleScrollWrapper}>
                <Box
                  dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                  className={styles.modalContent}
                />
              </Box>
            </Box>
          </Box>
        );
      }}
    </DataLoader>
  );
};

export default ViewFaq;
